'use client';

import { c as _c } from "react/compiler-runtime";
import { createWorkerClient, getOutcomeCount } from '../../../../lib/entry.browser.js';
import { useQuery } from '../../../../tanstack/entry.js';
import { outcomeDistributionOptions } from '../../../queryOptions/entry.js';
import { useEngine } from '../../engine/entry.js';
import { defaultWorker } from '../defaultWorker.js';
let workerApi = defaultWorker;
function handleBeforeUnload() {
  workerApi.terminate();
}
if (typeof window !== 'undefined') {
  // ----- IF MORE THREADS IS DESIRED -----
  // The creation of the worker can be moved inside the react hook inside a useMemo and teared down in an empty useEffect.
  // However, instantiating the worker in the hook will create a new worker thread upon every unique hook call,
  // ie. if two components calls the hook there will be two workers.
  workerApi = createWorkerClient(
  // Worker and URL must always coexist, see:
  // https://github.com/vercel/next.js/issues/31009
  new Worker(new URL('../bestBetRowsWorker.js', import.meta.url), {
    type: 'module'
  }));
  window.addEventListener('beforeunload', handleBeforeUnload);
}
/**
 * Hook that uses worker to get outcome distribution for wager.
 *
 * @param wagerId Wager Id to calculate outcome distribution for.
 * @param sportType sport type for current draw
 * @param eventType event type for current draw
 * @returns Outcome distribution for wager
 */
export function useOutcomeDistribution(wagerId, sportType, eventType) {
  const $ = _c(6);
  const definition = useEngine();
  let t0;
  let t1;
  if ($[0] !== definition || $[1] !== eventType || $[2] !== sportType || $[3] !== wagerId) {
    const outcomeCount = getOutcomeCount(sportType, eventType, definition.model);
    t0 = useQuery;
    t1 = outcomeDistributionOptions({
      wagerId,
      outcomeCount
    }, {
      post: workerApi.post,
      definition
    });
    $[0] = definition;
    $[1] = eventType;
    $[2] = sportType;
    $[3] = wagerId;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  return t0(t1);
}